import { createAsyncThunk } from '@reduxjs/toolkit'
import EmailReportService from '../../services/EmailReport/EmailReportService'

export const createEmailReport = createAsyncThunk('/emailReport', async (payload) => {
    const res = await EmailReportService.createEmailReport(payload)
    return res.data
})

export const getEmailReportList = createAsyncThunk('/emailReport', async (payload) => {
    const res = await EmailReportService.getEmailReportList(payload)
    return res.data
})

export const updateEmailReportById = createAsyncThunk('/emailReport', async (payload) => {
    const res = await EmailReportService.updateEmailReportById(payload)
    return res.data
})

export const deleteEmailReportById = createAsyncThunk('/emailReport', async (payload) => {
    const res = await EmailReportService.deleteEmailReportById(payload)
    return res.data
})
export const addProduct = createAsyncThunk('product/create', async (payload) => {
    const res = await EmailReportService.addProduct(payload);
    return res.data;
});

export const listOfProducts = createAsyncThunk('product/list', async (payload) => {
    const res = await EmailReportService.listOfProducts(payload);
    return res.data;
});

export const updateProducts = createAsyncThunk('product/update', async (payload) => {
    const res = await EmailReportService.updateProducts(payload);
    return res.data;
});

export const resendProductEamil = createAsyncThunk('product/resend', async (payload) => {
    const res = await EmailReportService.resendProductEamil(payload);
    return res.data;
});
